import { ROLE_LABELS } from './userConstants';

/**
 * The two letters in the avatar.
 *
 * From the name rather than the hardcoded "SN" the mockup carried. Falls back
 * to the email's first letter, because a user can have no name at all and an
 * empty circle looks broken.
 *
 * @param {object} user - The `get_user/` payload.
 * @returns {string}
 */
export const getInitials = (user) => {
  const first = (user?.first_name || '').trim();
  const last = (user?.last_name || '').trim();

  const initials = `${first.charAt(0)}${last.charAt(0)}`.trim();
  if (initials) return initials.toUpperCase();

  return (user?.email || '?').charAt(0).toUpperCase();
};

/** `admin` → "Administrador". Empty when the account carries no profile. */
export const getRoleLabel = (user) => ROLE_LABELS[user?.permission] || '';

/**
 * `1 de enero de 2024`.
 *
 * @param {string} value - ISO timestamp, `date_joined`.
 * @returns {string}
 */
export const formatLongDate = (value) => {
  if (!value) return '-';

  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '-';

  return date.toLocaleDateString('es-CL', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  });
};

/**
 * The plan, read from the **session** and not from `get_plan/`.
 *
 * That endpoint serialises `AdminPlan` with `fields = '__all__'`, where `plan`
 * is a ForeignKey — so it answers with the plan's id and never its name. The
 * name only ever travels in the login payload, which is where the legacy reads
 * it from too (`MyAccount.jsx:113`). So this costs no request.
 *
 * An account with no `AdminPlan` row gets `null` and the card says so, rather
 * than inventing the "Enterprise" the mockup had written in.
 *
 * @param {object} sessionUser - `state.auth.user`.
 * @returns {{ name: string, limit: string }|null}
 */
export const resolvePlan = (sessionUser) => {
  const plan = sessionUser?.admin_plan || sessionUser?.seller_admin_plan;
  if (!plan?.plan_name) return null;

  const monthOrders = plan.admin_permissions?.month_orders;

  return {
    name: plan.plan_name,
    limit:
      monthOrders === 0 || monthOrders === undefined || monthOrders === null
        ? 'Sin límite'
        : `${monthOrders.toLocaleString('es-CL')} órdenes/mes`,
  };
};
